import { envVars } from "@/plugins/env-vars";

fetch("/env.json")
  .then(r => {
    if (r.ok) {
      return r.json();
    }
  })
  .then(data => {
    if ("object" === typeof data) {
      envVars.setVars(data);
    }
  })
  .then(async () => {
    const response = await fetch("/localesOverride.json");

    window.OVERRIDE_TRANSLATE = response?.ok
      ? await response.json()
      : { ruLocale: {}, enLocale: {} };
  })
  .then(() => {
    return import("@/app-init");
  })
  .then(module => {
    const { default: init } = module;

    init();
  });
